"use strict";

//* =-=-=-=-=-=-=-=-=-=-=-=-=-= Start of Accolade Step 2 =-=-=-=-=-=-=-=-=-=-=-=-=-= *//

$(document).ready(function () {
  const locations = $(".cou-items");
  const locationOptions = $(".selectRegion");
  const step2SelectedElem = $(
    "#cou-find .cou-selected, #cou-select .cou-selected"
  );
  const ste2InputEem = $("input[type=search].cou-search");
  const step2MessageContainer = $("#step2AutoComplete");
  const step2CheckAllBtn = $("#checkAllCountries");
  const step2UncheckAllBtn = $("#unCheckAllCountries");

  function _step2SingleCheck() {
    $(locations).on("change", "input[type=checkbox]", function (event) {
      event.stopPropagation();

      const isChecked = $(this).is(":checked");
      const label = $(this).parent();
      const id = label.attr("data-id");
      const isoCode = label.attr("for");
      const name = label.children("input").attr("name");
      const img = label.find("img").attr("src");
      const price = parseFloat(label.attr("data-current-price"));
      const quantity = window.accolade.quantity;

      const extraId = label.attr("data-extra-id");
      const firstClassFee = parseFloat(label.attr("data-firstclass-fee"));
      const extraClassFee = parseFloat(label.attr("data-extraclass-fee"));

      const poaFee = parseFloat(label.attr("data-poa-fee"));
      const searchFee = parseFloat(label.attr("data-search-fee"));
      const mockFirstClassFee = parseFloat(
        label.attr("data-mock-first-classfee")
      );

      // Check both locationIndex and extraLocationIndex in one variable
      const locationIndex = accolade.locations.findIndex(
        (x) => x.id === id || x.id === extraId
      );

      if (isChecked) {
        $(label).addClass("checked");
        $(".step2Prev").removeClass("unable");
        $(".step2Next").removeClass("unable");

        if (locationIndex === -1) {
          if (quantity > 1) {
            //* Add Default item
            const cartObj = { id, quantity: 1 };

            //* Add Extra item
            const extraCartObj = { id: extraId, quantity: quantity - 1 };

            const locationObj = {
              id,
              extraId,
              name,
              isoCode,
              img,
              firstClassFee,
              extraClassFee,
              poaFee,
              searchFee,
              mockFirstClassFee,
              trademark : accolade.trademarks,
            };

            accolade.items.push(cartObj);
            accolade.items.push(extraCartObj);
            accolade.locations.push(locationObj);
            accolade.totalPrice += firstClassFee * quantity;

            _step2PillTabUI(step2SelectedElem, id, extraId, name, price);

            console.log(accolade.items);
          }

          //* If the quantity is 1
          if (quantity === 1) {
            const cartObj = { id, quantity };

            const locationObj = {
              id,
              extraId,
              name,
              isoCode,
              img,
              firstClassFee,
              extraClassFee,
              poaFee,
              searchFee,
              mockFirstClassFee,
              trademark : accolade.trademarks,
            };

            accolade.items.push(cartObj);
            accolade.locations.push(locationObj);
            accolade.totalPrice += extraClassFee * quantity;

            _step2PillTabUI(step2SelectedElem, id, extraId, name, price);

            console.log(accolade.items);
          }
        }
      } else {
        $(label).removeClass("checked");
        if(document.querySelectorAll('.cou-items input:checked').length === 0){
          $(".step2Next").addClass("unable");
          $("#step3tab").addClass("unable");
        }
        if (locationIndex !== -1) {
          accolade.locations = accolade.locations.filter(
            (x) => x.id !== id && x.id !== extraId
          );
          accolade.items = accolade.items.filter(
            (x) => x.id !== id && x.id !== extraId
          );

          // Remove the pill tab
          $(`p.badge[data-id="${id}"]`).remove();
          $(`p.badge[data-extra-id="${extraId}"]`).remove();

          console.log(accolade.items);
        }
      }
    });

    $(locationOptions).on("change", function (event) {
      event.stopPropagation();

      const option = $(this).find("option:selected");

      const id = option.attr("data-id");
      const isoCode = option.attr("data-iso-code");
      const name = option.attr("data-name");
      const img = option.attr("data-img");
      const price = parseFloat(option.attr("data-current-price")); // Parse price as a float
      const quantity = accolade.quantity;

      const extraId = option.attr("data-extra-id");
      const firstClassFee = parseFloat(option.attr("data-firstclass-fee"));
      const extraClassFee = parseFloat(option.attr("data-extraclass-fee"));
      const poaFee = parseFloat(option.attr("data-poa-fee"));
      const searchFee = parseFloat(option.attr("data-search-fee"));
      const mockFirstClassFee = parseFloat(
        option.attr("data-mock-first-classfee")
      );

      const locationIndex = accolade.locations.findIndex(
        (x) => x.id === id || x.id === extraId
      );

      if (locationIndex === -1) {
        if (quantity > 1) {
          const cartObj = { id, quantity: 1 };

          const extraCartObj = { id: extraId, quantity: quantity - 1 };

          const locationObj = {
            id,
            extraId,
            name,
            isoCode,
            img,
            firstClassFee,
            extraClassFee,
            poaFee,
            searchFee,
            mockFirstClassFee,
            trademark : accolade.trademarks,
          };

          accolade.items.push(cartObj);
          accolade.items.push(extraCartObj);
          accolade.locations.push(locationObj);
          accolade.totalPrice += firstClassFee * quantity;

          $(locations).find(`label[data-id="${id}"]`).addClass("checked");

          _step2PillTabUI(step2SelectedElem, id, extraId, name, price);
        }

        if (quantity === 1) {
          const cartObj = { id, quantity };

          const locationObj = {
            id,
            extraId,
            name,
            isoCode,
            img,
            firstClassFee,
            extraClassFee,
            poaFee,
            searchFee,
            mockFirstClassFee,
            trademark : accolade.trademarks,
          };

          accolade.items.push(cartObj);
          accolade.locations.push(locationObj);
          accolade.totalPrice += extraClassFee * quantity;

          $(locations).find(`label[data-id="${id}"]`).addClass("checked");
          _step2PillTabUI(step2SelectedElem, id, extraId, name, price);
        }
      }
    });
  }

  function _step2CheckAllAndUncheckAll() {
    let clicked = false;

    $(step2CheckAllBtn).click(function (event) {
      event.stopPropagation();

      $(locations).find("input[type=checkbox]").prop("checked", true);
      $(locations).find("label").addClass("checked");

      $(".step2Prev").removeClass("unable");
      $(".step2Next").removeClass("unable");

      if (clicked) return;

      // If all checkboxes are checked, update the accolade.locations array and pill tabs UI
      $(locations)
        .find("label")
        .each(function () {
          const id = $(this).attr("data-id");
          const isoCode = $(this).attr("for");
          const name = $(this).children("input").attr("name");
          const img = $(this).find("img").attr("src");
          const price = parseFloat($(this).attr("data-current-price"));
          const quantity = window.accolade.quantity;

          const extraId = $(this).attr("data-extra-id");
          const firstClassFee = parseFloat($(this).attr("data-firstclass-fee"));
          const extraClassFee = parseFloat($(this).attr("data-extraclass-fee"));

          const poaFee = parseFloat($(this).attr("data-poa-fee"));
          const searchFee = parseFloat($(this).attr("data-search-fee"));
          const mockFirstClassFee = parseFloat($(this).attr("data-mock-first-classfee"));

          const locationIndex = accolade.locations.findIndex(
            (x) => x.id === id || x.id === extraId
          );

          if (locationIndex === -1) {
            if (quantity > 1) {
              const cartObj = { id, quantity: 1 };

              const extraCartObj = { id: extraId, quantity: quantity - 1 };

              const locationObj = {
                id,
                extraId,
                name,
                isoCode,
                img,
                firstClassFee,
                extraClassFee,
                poaFee,
                searchFee,
                mockFirstClassFee,
                trademark : accolade.trademarks,
              };

              accolade.items.push(cartObj);
              accolade.items.push(extraCartObj);
              accolade.locations.push(locationObj);
              accolade.totalPrice += firstClassFee * quantity;

              _step2PillTabUI(step2SelectedElem, id, extraId, name, price);

              console.log(accolade);
            }

            if (quantity === 1) {
              const cartObj = { id, quantity };

              const locationObj = {
                id,
                extraId,
                name,
                isoCode,
                img,
                firstClassFee,
                extraClassFee,
                poaFee,
                searchFee,
                mockFirstClassFee,
                trademark : accolade.trademarks,
              };

              accolade.items.push(cartObj);
              accolade.locations.push(locationObj);
              accolade.totalPrice += extraClassFee * quantity;

              _step2PillTabUI(step2SelectedElem, id, extraId, name, price);

              console.log(accolade);
            }

            clicked = true;
            console.log(accolade);
          }
        });
    });

    $(step2UncheckAllBtn).click(function (event) {
      event.stopPropagation();

      $(locations).find("input[type=checkbox]").prop("checked", false);

      $(".step2Next").addClass("unable");

      // If all checkboxes are unchecked, clear the accolade.locations array and pill tabs UI
      accolade.locations = [];
      accolade.items = [];
      accolade.totalPrice = 0;

      $(step2SelectedElem).find("p.badge").remove();
      $(locations).find("label").removeClass("checked");

      clicked = false;

      console.log(accolade);
    });
  }

  function _step2PillTabUI(selector, id, extraId, name, price) {
    // Remove any existing pill tabs with the same 'data-id' attribute
    $(selector).find(`p.badge[data-id="${id}"]`).remove();
    $(selector).find(`p.badge[data-extra-id="${extraId}"]`).remove();

if(name !== "fade" || name !== "fade2" ){

    // Append the new pill tab HTML
    $(selector).each(function (index, elem) {
      const html = `
        <p class="badge badge-info" data-id="${id}" data-extra-id="${extraId}">
          <span>${name}</span>
          <button type="button" class="close" aria-label="Close" data-id="${id}" data-extra-id="${extraId}">
            <span aria-hidden="true" data-id="${id}">×</span>
          </button>
        </p>
      `;

      $(elem).append(html);
    });

}


    $(selector)
      .find(`button[data-id="${id}"]`)
      .on("click", function (event) {
        event.stopPropagation();

        const pillTab = $(this).closest("p.badge[data-id]");
        const correspondingCheckbox = $(`.cou-items label[data-id="${id}"]`);

        if (pillTab.length > 0) {
          pillTab.remove();

          // Remove the pill tab from both #cou-find and #cou-select
          $("#cou-find").find(`p.badge[data-id="${id}"]`).remove();
          $("#cou-find").find(`p.badge[data-extra-id="${extraId}"]`).remove();
          $("#cou-select").find(`p.badge[data-id="${id}"]`).remove();
          $("#cou-select").find(`p.badge[data-extra-id="${extraId}"]`).remove();

          correspondingCheckbox
            .find("input[type='checkbox']")
            .prop("checked", false);
          correspondingCheckbox.removeClass("checked");

          // Update the accolade.locations array
          const locationIndex = accolade.locations.findIndex(
            (x) => x.id === id || x.id === extraId
          );

          if (locationIndex !== -1) {
            // Filter to remove the location from the array
            accolade.locations = accolade.locations.filter(
              (x) => x.id !== id && x.id !== extraId
            );
            accolade.items = accolade.items.filter(
              (x) => x.id !== id && x.id !== extraId
            );

            // Update the total price
            accolade.totalPrice -= parseFloat(price) * accolade.quantity;

            console.log(accolade);
          }
        }
      });
  }

  function _sorting() {
    // Sort A-Z
    $("#sortingBtn .az").click(function (event) {
      event.stopPropagation();

      $(".cou-items label")
        .sort(function (a, b) {
          return $(a).find("input").attr("name") >
            $(b).find("input").attr("name")
            ? 1
            : -1;
        })
        .appendTo(".cou-items");

      $(this).addClass("hide");
      $("#sortingBtn .za").removeClass("hide");
    });

    // Sort Z-A
    $("#sortingBtn .za").click(function (event) {
      event.stopPropagation();

      $(".cou-items label")
        .sort(function (a, b) {
          return $(a).find("input").attr("name") <
            $(b).find("input").attr("name")
            ? 1
            : -1;
        })
        .appendTo(".cou-items");

      $(this).addClass("hide");
      $("#sortingBtn .az").removeClass("hide");
    });
  }

  function _step2SearchFilter() {
    // Implement simple filter for the location list
    let debounceTimer;

    function highlightMatchedWords(label, pattern) {
      return label.replace(
        pattern,
        (match) => `<span class="highlight">${match}</span>`
      );
    }

    function updateSearchResults() {
      const searchValue = $(ste2InputEem).val().trim().toLowerCase();
      const searchWords = searchValue.split("、").map((word) => word.trim());
      const pattern = new RegExp(searchWords.join("|"), "gi");
      const locationList = $(".cou-items");
      const matchedItems = [];

      if (searchValue === "") {
        step2MessageContainer.empty();
        locationList.find("label").show();
      } else {
        locationList.find("label").each(function () {
          const id = $(this).attr("data-id");
          const name = $(this).attr("data-full-name");
          const isoCode = $(this).attr("for");
          // const img = $(this).find("img").attr("src");
          // const price = parseFloat($(this).attr("data-current-price"));
          const checkbox = $(this).find("input[type=checkbox]");
          const isChecked = checkbox.is(":checked");

          const isMatches =
            name.toLowerCase().match(pattern) ||
            isoCode.toLowerCase().match(pattern);

          if (isMatches) {
            checkbox.parent().show();
            const label = $(this).attr("data-full-name").trim();
            const highlightedLabel = highlightMatchedWords(label, pattern);
            matchedItems.push({ label: highlightedLabel, id, isChecked });
          } else {
            checkbox.parent().hide();
          }

          //! Fixed auto complete bug
          if (matchedItems.length > 0) {
            const autoCompletedHTML = matchedItems
              .map((item) => {
                // Retrieve the correct data from the corresponding label element
                const label = $(`.cou-items label[data-id="${item.id}"]`);
                const isoCode = label.attr("for");
                const name = label.attr("data-full-name");
                const img = label.find("img").attr("src");
                const price = parseFloat(label.attr("data-current-price"));
                const isChecked = label
                  .find("input[type=checkbox]")
                  .is(":checked");

                const extraId = $(label).attr("data-extra-id");
                const firstClassFee = parseFloat(
                  $(label).attr("data-firstclass-fee")
                );
                const extraClassFee = parseFloat(
                  $(label).attr("data-extraclass-fee")
                );
                const mockFirstClassFee = parseFloat(
                  $(label).attr("data-mock-first-classfee")
                );
                const poaFee = parseFloat($(label).attr("data-poa-fee"));
                const searchFee = parseFloat($(label).attr("data-search-fee"));

                return `
                  <li class="showedItems"
                    data-id="${item.id}"
                    data-iso-code="${isoCode}"
                    data-full-name="${name}"
                    data-current-price="${price}"
                    data-img="${img}"
                    data-extra-id="${extraId}"
                    data-firstclass-fee="${firstClassFee}"
                    data-extraclass-fee="${extraClassFee}"
                    data-mock-first-classfee="${mockFirstClassFee}"
                    data-poa-fee="${poaFee}"
                    data-search-fee="${searchFee}"
                  >
                    ${item.label}
                  </li>
                `;
              })
              .join("");

            step2MessageContainer.html(autoCompletedHTML);
          } else {
            step2MessageContainer.html("<li>No matches found</li>");
          }
        });
      }
    }

    function updateCheckboxAndPillTab(
      id,
      name,
      isoCode,
      img,
      price,
      isChecked,
      extraId,
      firstClassFee,
      extraClassFee,
      mockFirstClassFee,
      poaFee,
      searchFee
    ) {
      const checkbox = $(`.cou-items label[data-id="${id}"]`).find(
        "input[type=checkbox]"
      );

      if (isChecked) {
        // First check if the location is already in the array
        const locationIndex = accolade.locations.findIndex(
          (x) => x.id === id || x.id === extraId
        );

        if (locationIndex === -1) {
          if (accolade.quantity > 1) {
            //* Add Default item
            const cartObj = { id, quantity: 1 };

            //* Add Extra item
            const extraCartObj = {
              id: extraId,
              quantity: accolade.quantity - 1,
            };

            const locationObj = {
              id,
              extraId,
              name,
              isoCode,
              img,
              firstClassFee,
              extraClassFee,
              poaFee,
              searchFee,
              mockFirstClassFee,
              trademark : accolade.trademarks,
            };

            accolade.items.push(cartObj);
            accolade.items.push(extraCartObj);
            accolade.locations.push(locationObj);
            accolade.totalPrice += firstClassFee * accolade.quantity;

            _step2PillTabUI(step2SelectedElem, id, extraId, name, price);

            console.log(accolade.items);
          }

          //* If the quantity is 1
          if (accolade.quantity === 1) {
            const cartObj = { id, quantity: accolade.quantity };

            const locationObj = {
              id,
              extraId,
              name,
              isoCode,
              img,
              firstClassFee,
              extraClassFee,
              poaFee,
              searchFee,
              mockFirstClassFee,
              trademark : accolade.trademarks,
            };

            accolade.items.push(cartObj);
            accolade.locations.push(locationObj);
            accolade.totalPrice += extraClassFee * accolade.quantity;

            _step2PillTabUI(step2SelectedElem, id, extraId, name, price);

            console.log(accolade.items);
          }
        }
      } else {
        // Remove the location from the array
        const locationIndex = accolade.locations.findIndex(
          (x) => x.id === id || x.id === extraId
        );

        if (locationIndex !== -1) {
          accolade.locations = accolade.locations.filter(
            (x) => x.id !== id && x.id !== extraId
          );

          accolade.items = accolade.items.filter(
            (x) => x.id !== id && x.id !== extraId
          );

          // Remove the pill tab from both #cou-find and #cou-select
          $("#cou-find").find(`p.badge[data-id="${id}"]`).remove();
          $("#cou-find").find(`p.badge[data-extra-id="${extraId}"]`).remove();
          $("#cou-select").find(`p.badge[data-id="${id}"]`).remove();
          $("#cou-select").find(`p.badge[data-extra-id="${extraId}"]`).remove();

          accolade.totalPrice -= parseFloat(price) * accolade.quantity;

          console.log(accolade);
        }
      }

      // Update the checkboxes
      checkbox.prop("checked", isChecked);
      checkbox.parent().toggleClass("checked", isChecked);

      console.log(accolade);
    }

    $(ste2InputEem).on("input", function (event) {
      event.stopPropagation();

      $("#step2AutoComplete").show();

      // Clear the previous debounce timer
      clearTimeout(debounceTimer);

      // Set a new debounce timer to limit function calls
      debounceTimer = setTimeout(() => {
        updateSearchResults();
      }, 300); // Set the debounce delay to 300 milliseconds (adjust as needed)
    });

    $(ste2InputEem).on("keydown", function (event) {
      // Handle the Enter key press separately
      if (event.keyCode === 13) {
        event.preventDefault();

        // Clear the step2MessageContainer when Enter key is pressed
        step2MessageContainer.empty();
      }
    });

    // Event handler for clicking on the autocomplete result
    step2MessageContainer.on("click", "li", function () {
      const id = $(this).attr("data-id");
      const label = $(this).attr("data-full-name");
      const isoCode = $(this).attr("data-iso-code");
      const img = $(this).attr("data-img");
      const price = parseFloat($(this).attr("data-current-price"));
      const checkbox = $(`.cou-items label[data-id="${id}"]`).find(
        "input[type=checkbox]"
      );
      const isChecked = !checkbox.is(":checked");

      const extraId = $(this).attr("data-extra-id");
      const firstClassFee = parseFloat($(this).attr("data-firstclass-fee"));
      const extraClassFee = parseFloat($(this).attr("data-extraclass-fee"));
      const mockFirstClassFee = $(this).attr("data-mock-first-classfee");
      const poaFee = parseFloat($(this).attr("data-poa-fee"));
      const searchFee = parseFloat($(this).attr("data-search-fee"));

      // Update the checkbox and pill tab UI
      updateCheckboxAndPillTab(
        id,
        label,
        isoCode,
        img,
        price,
        isChecked,
        extraId,
        firstClassFee,
        extraClassFee,
        mockFirstClassFee,
        poaFee,
        searchFee
      );

      // Hide the step2MessageContainer after clicking the autocomplete result
      step2MessageContainer.empty();

      $(".step2Next").removeClass("unable");
    });
  }

  function _totalPriceShouldNotBeLessThanZero() {
    if (accolade.totalPrice < 0) {
      accolade.totalPrice = 0;
    }
  }

  _step2SingleCheck();
  _step2CheckAllAndUncheckAll();
  _step2SearchFilter();
  _sorting();

  let interval = setInterval(() => {
    _totalPriceShouldNotBeLessThanZero();
  }, 100);

  //* =-=-=-=-=-=-=-=-=-=-=-=-=-= End of Accolade Step 2 =-=-=-=-=-=-=-=-=-=-=-=-=-= *//
});

document.querySelectorAll("#cou-tabbody .cou-group").forEach((e)=>{e.onmouseover = ()=>{
  try {
      document.querySelector("#cou-tabbody .cou-items #removefade1st .item.hide").click();
  } catch (error) {}
  document.querySelector("#removefade1st").innerHTML = ""
}   })